// extracted by mini-css-extract-plugin
export default {"form":"register_form__zqnAR","title":"register_title__x7xsk","fields":"register_fields__8kckw","ViewLabel":"register_ViewLabel__7uBkR"};